// extracted by mini-css-extract-plugin
export default {"descOne":"DescOne_descOne__OVdfd"};